import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { EvsUserService } from '../../../../../../common/services/EvsUser.service';
import { EvsStoreService } from '../../../../../../common/services/EvsStore.service';
import { EvsAddressService } from '../../../../../../common/services/EvsAddress.service';
import { EvsProductService } from '../../../../../../common/services/EvsProduct.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService, Message } from 'primeng/primeng';
import { BatchService } from '../../../../qrcode/batchstamp/batch.service';
import { ImageService } from '../../../../../imageService';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: 'app-log-manager',
  templateUrl: './log-manager.component.html',
  styleUrls: ['./log-manager.component.css'],
  providers: [
    EvsUserService,
    EvsStoreService,
    EvsAddressService,
    ConfirmationService,
    EvsProductService,
    ImageService
  ]
})
export class LogManagerComponent implements OnInit, OnDestroy {
  constructor(
    private evsUserService: EvsUserService,
    private evsStoreService: EvsStoreService,
    private evsProductService: EvsProductService,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    private confirmationService: ConfirmationService,
    private batchService: BatchService,
    private imageService: ImageService,
    private translate: TranslateService,
  ) {
  }

  @Input('user') user: any;
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  cities: any = [];
  page_size: number = 10;
  storeCurrentPage: number = 1;
  areaCurrentPage: number = 1;
  batchCurrentPage: number = 1;
  productCurrentPage: number = 1;
  storeOffset: number = 0;
  areaOffset: number = 0;
  batchOffset: number = 0;
  productOffset: number = 0;
  distribution_stores: any = [];
  distribution_cities: any = [];
  batches: any = [];
  products: any = [];
  services: any = {
    chonggia: false,
    baohanh: false,
    tranhang: false,
    dinhdanh: false
  };
  store: any = {};
  listStore: any = [];
  storeFocus: boolean = false;
  batch: any = {};
  listBatch: any = [];
  batchFocus: boolean = false;
  product: any = {};
  listProduct: any = [];
  productFocus: boolean = false;
  isStore: boolean = true;
  private langSub: Subscription;

  ngOnInit() {
    this.initSelect2();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
    });
    this.getCity();
    this.getData();
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  initSelect2() {
    let store_distribution = $('#store_distribution');
    store_distribution.select2({
      placeholder: this.translate.instant('TINH_TP'),
      allowClear: false,
      width: '100%'
    });
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id
        });
      });
      this.cities = citiesList;
    });
  }

  getBatch() {
    if (this.batch.name) {
      let data_get: any = {
        limit: 100,
        offset: 0,
        show_child: 1,
        name: this.batch.name
      };
      this.batchService.getBatchesList(data_get).subscribe(res => {
        if (!res.error) {
          this.listBatch = res.data.batches;
        }
      });
    }
  }

  getProduct() {
    if (this.product.name) {
      let data_get: any = {
        limit: 100,
        offset: 0,
        name: this.product.name
      };
      this.evsProductService.all(data_get).subscribe(res => {
        if (!res.error) {
          this.listProduct = res.data.products;
        }
      });
    }
  }

  getData() {
    let request: any = {};
    request.offset =
      this.page_size *
      (this.storeCurrentPage <= 0 ? 0 : this.storeCurrentPage - 1);
    request.limit = this.page_size;
    request.type = 'log';
    this.evsUserService
      .getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          let services = res.data.log.services;
          for (let i = 0; i < services.length; i++) {
            switch (services[i].id) {
              case 1: {
                this.services.chonggia = true;
                break;
              }
              case 2: {
                this.services.baohanh = true;
                break;
              }
              case 3: {
                this.services.tranhang = true;
                break;
              }
              case 5: {
                this.services.dinhdanh = true;
                break;
              }
            }
          }
          this.distribution_stores = res.data.log.distribution_stores;
          this.distribution_cities = res.data.log.distribution_cities;
          this.products = res.data.log.products;
          for (let i = 0; i < this.products.length; i++) {
            this.products[i].image = this.imageService.readSrcImage(
              this.products[i].image,
              'thumb_medium'
            );
          }
          this.batches = res.data.log.batches;
          for (let i = 0; i < this.batches.length; i++) {
            let listServcies = this.batches[i].services.split(',');
            if (listServcies) {
              if (listServcies.length > 0) {
                let servicesName: any = [];
                for (let s = 0; s < listServcies.length; s++) {
                  switch (listServcies[s]) {
                    case '1': {
                      servicesName.push(this.translate.instant('CHONG_GIA'));
                      break;
                    }
                    case '2': {
                      servicesName.push(this.translate.instant('BAO_HANH'));
                      break;
                    }
                    case '3': {
                      servicesName.push(this.translate.instant('TRAN_HANG'));
                      break;
                    }
                    case '5': {
                      servicesName.push(this.translate.instant('DINH_DANH'));
                      break;
                    }
                  }
                }
                if (servicesName.length > 0) {
                  this.batches[i].services = servicesName;
                } else {
                  this.batches[i].services = [];
                }
              }
            }
          }
        }
      });
  }

  searchStore() {
    if (this.store.name) {
      let request: any = {
        limit: 100,
        offset: 0,
        name: this.store.name
      };
      this.evsStoreService.all(request).subscribe(res => {
        if (!res.error) {
          if (res.data) {
            this.listStore = res.data.store;
          } else {
            this.listStore = [];
          }
        }
      });
    }
  }

  focusoutStore() {
    setTimeout(() => {
      this.storeFocus = false;
    }, 200);
  }

  focusoutBatch() {
    setTimeout(() => {
      this.batchFocus = false;
    }, 200);
  }

  focusoutProduct() {
    setTimeout(() => {
      this.productFocus = false;
    }, 200);
  }

  addStore() {
    if (this.store.id) {
      let data: any = {
        log: {
          store: this.store.id
        }
      };
      this.evsUserService
        .postMaganerPermission(this.user.id, data)
        .subscribe(res => {
          if (!res.error) {
            this.toastr.success(
              this.translate.instant('QUAN_LY_LOG_PHAN_PHOI_CUA_HANG_SUCCESS')
            );
            this.storePage();
          }
        });
    }
  }

  addArea() {
    if ($('#store_distribution').val()) {
      let city = parseInt($('#store_distribution').val());
      let data: any = {
        log: {
          city: city
        }
      };
      this.evsUserService
        .postMaganerPermission(this.user.id, data)
        .subscribe(res => {
          if (!res.error) {
            this.toastr.success(this.translate.instant('THEM_QUYEN_KHU_VUC_THANH_CONG'));
            this.areaPage();
          }
        });
    }
  }

  addbatch() {
    if (this.batch.id) {
      let data: any = {
        log: {
          batch: this.batch.id
        }
      };
      this.evsUserService
        .postMaganerPermission(this.user.id, data)
        .subscribe(res => {
          if (!res.error) {
            this.toastr.success(this.translate.instant('QUAN_LY_LOG_LO_TEM_SUCCESS'));
            this.batchPage();
          }
        });
    }
  }

  addProduct() {
    if (this.product.id) {
      let data: any = {
        log: {
          product: this.product.id
        }
      };
      this.evsUserService
        .postMaganerPermission(this.user.id, data)
        .subscribe(res => {
          if (!res.error) {
            this.toastr.success(this.translate.instant('QUAN_LY_LOG_SAN_PHAM_SUCCESS'));
            this.productPage();
          }
        });
    }
  }

  storePage() {
    let request: any = {};
    request.offset =
      this.page_size *
      (this.storeCurrentPage <= 0 ? 0 : this.storeCurrentPage - 1);
    this.storeOffset = request.offset;
    request.limit = this.page_size;
    request.type = 'log';
    this.evsUserService
      .getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.distribution_stores = res.data.log.distribution_stores;
          if (
            this.storeCurrentPage > 1 &&
            (!this.distribution_stores || this.distribution_stores.length == 0)
          ) {
            this.storeCurrentPage--;
            this.storePage();
            this.toastr.warning(this.translate.instant('BAN_DANG_O_TRANG_CUOI_CUNG'));
          }
        }
      });
  }

  areaPage() {
    let request: any = {};
    request.offset =
      this.page_size *
      (this.areaCurrentPage <= 0 ? 0 : this.areaCurrentPage - 1);
    this.areaOffset = request.offset;
    request.limit = this.page_size;
    request.type = 'log';
    this.evsUserService
      .getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.distribution_cities = res.data.log.distribution_cities;
          if (
            this.areaCurrentPage > 1 &&
            (!this.distribution_cities || this.distribution_cities.length == 0)
          ) {
            this.areaCurrentPage--;
            this.areaPage();
            this.toastr.warning(this.translate.instant('BAN_DANG_O_TRANG_CUOI_CUNG'));
          }
        }
      });
  }

  batchPage() {
    let request: any = {};
    request.offset =
      this.page_size *
      (this.batchCurrentPage <= 0 ? 0 : this.batchCurrentPage - 1);
    this.batchOffset = request.offset;
    request.limit = this.page_size;
    request.type = 'log';
    this.evsUserService
      .getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.batches = res.data.log.batches;
          if (
            this.batchCurrentPage > 1 &&
            (!this.batches || this.batches.length == 0)
          ) {
            this.batchCurrentPage--;
            this.batchPage();
            this.toastr.warning(this.translate.instant('BAN_DANG_O_TRANG_CUOI_CUNG'));
          }
          for (let i = 0; i < this.batches.length; i++) {
            let listServcies = this.batches[i].services.split(',');
            if (listServcies) {
              if (listServcies.length > 0) {
                let servicesName: any = [];
                for (let s = 0; s < listServcies.length; s++) {
                  switch (listServcies[s]) {
                    case '1': {
                      servicesName.push(this.translate.instant('CHONG_GIA'));
                      break;
                    }
                    case '2': {
                      servicesName.push(this.translate.instant('BAO_HANH'));
                      break;
                    }
                    case '3': {
                      servicesName.push(this.translate.instant('TRAN_HANG'));
                      break;
                    }
                    case '5': {
                      servicesName.push(this.translate.instant('DINH_DANH'));
                      break;
                    }
                  }
                }
                if (servicesName.length > 0) {
                  this.batches[i].services = servicesName;
                } else {
                  this.batches[i].services = [];
                }
              }
            }
          }
        }
      });
  }

  productPage() {
    let request: any = {};
    request.offset =
      this.page_size *
      (this.productCurrentPage <= 0 ? 0 : this.productCurrentPage - 1);
    this.productOffset = request.offset;
    request.limit = this.page_size;
    request.type = 'log';
    this.evsUserService
      .getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.products = res.data.log.products;
          for (let i = 0; i < this.products.length; i++) {
            this.products[i].image = this.imageService.readSrcImage(
              this.products[i].image,
              'thumb_medium'
            );
          }
          if (
            this.productCurrentPage > 1 &&
            (!this.products || this.products.length == 0)
          ) {
            this.productCurrentPage--;
            this.productPage();
            this.toastr.warning(this.translate.instant('BAN_DANG_O_TRANG_CUOI_CUNG'));
          }
        }
      });
  }

  changeStatus(service) {
    switch (service) {
      case 1: {
        if (this.services.chonggia == true) {
          this.createService(1);
        } else {
          this.deleteService(1);
        }
        break;
      }
      case 2: {
        if (this.services.baohanh == true) {
          this.createService(2);
        } else {
          this.deleteService(2);
        }
        break;
      }
      case 3: {
        if (this.services.tranhang == true) {
          this.createService(3);
        } else {
          this.deleteService(3);
        }
        break;
      }
      case 5: {
        if (this.services.dinhdanh == true) {
          this.createService(5);
        } else {
          this.deleteService(5);
        }
        break;
      }
    }
  }

  createService(service) {
    let data: any = {
      log: {
        service: service
      }
    };
    this.evsUserService
      .postMaganerPermission(this.user.id, data)
      .subscribe(res => {
        if (!res.error) {
          this.toastr.info(
            this.translate.instant('DA_THEM_QUYEN_QUAN_LY_LOG') + ' ' +
            (service == 1
              ? this.translate.instant('CHONG_GIA')
              : service == 2
                ? this.translate.instant('BAO_HANH')
                : service == 3
                  ? this.translate.instant('TRAN_HANG')
                  : service == 5
                    ? this.translate.instant('DINH_DANH')
                    : '')
          );
        }
      });
  }

  deleteService(service) {
    let data: any = {
      log: {
        service: service
      }
    };
    this.evsUserService
      .deleteMaganerPermission(this.user.id, data)
      .subscribe(res => {
        if (!res.error) {
          this.toastr.info(
            this.translate.instant('DA_XOA_QUYEN_QUAN_LY_LOG') + ' ' +
            (service == 1
              ? this.translate.instant('CHONG_GIA')
              : service == 2
                ? this.translate.instant('BAO_HANH')
                : service == 3
                  ? this.translate.instant('TRAN_HANG')
                  : service == 5
                    ? this.translate.instant('DINH_DANH')
                    : '')
          );
        }
      });
  }

  deleteStore(store) {
    this.confirmationService.confirm({
      message: this.translate.instant('XAC_NHAN_XOA_QUYEN_CUA_HANG'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        let data: any = {
          log: {
            store: store.id
          }
        };
        this.evsUserService
          .deleteMaganerPermission(this.user.id, data)
          .subscribe(res => {
            if (!res.error) {
              this.toastr.info(this.translate.instant('DA_XOA_QUYEN_CUA_HANG') + ' ' + store.name);
              this.storePage();
            }
          });
      }
    });
  }

  deleteArea(city) {
    this.confirmationService.confirm({
      message: this.translate.instant('XAC_NHAN_XOA_QUYEN_KHU_VUC'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        let data: any = {
          log: {
            city: city.id
          }
        };
        this.evsUserService
          .deleteMaganerPermission(this.user.id, data)
          .subscribe(res => {
            if (!res.error) {
              this.toastr.info(this.translate.instant('BAN_VUA_XOA_QUYEN_KHU_VUC') + ' ' + city.name);
              this.areaPage();
            }
          });
      }
    });
  }

  deleteBatch(batch) {
    this.confirmationService.confirm({
      message: this.translate.instant('XAC_NHAN_XOA_QUYEN_LO_TEM'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        let data: any = {
          log: {
            batch: batch.id
          }
        };
        this.evsUserService
          .deleteMaganerPermission(this.user.id, data)
          .subscribe(res => {
            if (!res.error) {
              this.toastr.info(this.translate.instant('DA_XOA_QUYEN_LO_TEM') + ' ' + batch.name);
              this.batchPage();
            }
          });
      }
    });
  }

  deleteProduct(product) {
    this.confirmationService.confirm({
      message: this.translate.instant('XAC_NHAN_XOA_QUYEN_SAN_PHAM'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        let data: any = {
          log: {
            product: product.id
          }
        };
        this.evsUserService
          .deleteMaganerPermission(this.user.id, data)
          .subscribe(res => {
            if (!res.error) {
              this.toastr.info(this.translate.instant('DA_XOA_QUYEN_SAN_PHAM') + ' ' + product.name);
              this.productPage();
            }
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/modal-manager/log-manager/log-manager.component.ts